jQuery(document).ready(() => {
  const menuController = Router.getController('customer.account.menuController');
  menuController.setRedirect(true);

  $('.content').addClass('in');

  $('.select-month').select2({
    placeholder: 'Select Month',
    minimumResultsForSearch: Infinity
  });
  $('.select-year').select2({
    placeholder: 'Select Year',
    minimumResultsForSearch: Infinity
  });
  $('#account-type').select2({
    placeholder: 'Select Account Type',
    minimumResultsForSearch: Infinity
  });

  checkPaymentType($('input[name="payCheckbox"]:checked').val());

  $('#submit-podcast').click(() => {
    bootbox.confirm({
      title: 'Podcast confirmation',
      message: 'Are you sure to add podcast to your license?',
      buttons: {
        confirm: {
          label: 'Yes',
          className: 'btn-success'
        },
        cancel: {
          label: 'No',
          className: 'btn-danger'
        }
      },
      callback(result) {
        if (result) {
          $('#submit-podcast').button('loading');

          const id = $('#submit-podcast').data('id-invoice');

          $.post(addPodcastUrl, {
            id
          }, (data, b) => {
            if (data.isError == 1) {
              $('#submit-podcast').button('reset');

              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success('License has been successfully upgraded to Podcast', 'Success');

              location.reload();
            }
          });
        }
      }
    });
  });

  $('#payVisa, #payACH').on('click', function () {
    checkPaymentType($(this).val());
  });


  function checkPaymentType(value) {
    if (value == 'payVisa') {
      $('#payment').addClass('visible');
      $('#achpayment').removeClass('visible');
      $('#payment').css('display', 'block');
      $('#achpayment').css('display', 'none');
    } else {
      $('#payment').removeClass('visible');
      $('#achpayment').addClass('visible');
      $('#payment').css('display', 'none');
      $('#achpayment').css('display', 'block');
    }
  }
});
